import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { updateDoc, doc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from './AuthContext';
import { useNotificationsAggregate } from '../utils/useNotificationsAggregate';
import { updateNotificationsAggregationOnUpdate } from '../utils/notificationsAggregations';

const NotificationContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const { user } = useAuth();
  const { notifications: allNotifications, loading } = useNotificationsAggregate();
  
  // Filtrar e normalizar notificações
  const notifications = useMemo(() => {
    if (!user) return [];
    
    let notificationsData = allNotifications;
        
    // Filtrar no cliente: apenas do usuário (se tiver idUsuario)
        notificationsData = notificationsData.filter(n => {
      if (n.idUsuario && n.idUsuario !== user.uid) return false;
          return true;
        });
        
    // Normalizar campo lida: sempre booleano
        notificationsData = notificationsData.map(n => ({
          ...n,
      lida: n.lida === true || n.lida === 'true' || n.lida === 1
        }));
        
    return notificationsData;
  }, [allNotifications, user]);
  
  const unreadCount = useMemo(() => {
    return notifications.filter(n => !n.lida).length;
  }, [notifications]);

  const markAsRead = async (notificationId) => {
    const notification = notifications.find(n => n.id === notificationId);
    if (!notification) return;
    
    const notificationRef = doc(db, 'notificacoes', notificationId);
    const updatedData = {
      lida: true,
      lidaEm: Timestamp.now()
    };
    
    await updateDoc(notificationRef, updatedData);
    
    // Atualizar agregado de notificações
    try {
      await updateNotificationsAggregationOnUpdate({
        ...notification,
        ...updatedData
      });
    } catch (err) {
      // Erro ao atualizar agregado de notificações
    }
  };

  const markAllAsRead = async () => {
    const unreadNotifications = notifications.filter(n => !n.lida);
    
    if (unreadNotifications.length === 0) return;
    
    const updatePromises = unreadNotifications.map(async (notif) => {
      const notificationRef = doc(db, 'notificacoes', notif.id);
      const updatedData = {
        lida: true,
        lidaEm: Timestamp.now()
      };
      
      await updateDoc(notificationRef, updatedData);
      
      // Atualizar agregado de notificações
      try {
        await updateNotificationsAggregationOnUpdate({
          ...notif,
          ...updatedData
        });
      } catch (err) {
        // Erro ao atualizar agregado de notificações
      }
    });
    
    await Promise.all(updatePromises);
  };

  return (
    <NotificationContext.Provider value={{
      notifications,
      unreadCount,
      markAsRead,
      markAllAsRead
    }}>
      {children}
    </NotificationContext.Provider>
  );
};










